/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../../../graphql/src/lib/graphql/generated/types'

const defaultOptions = {} as const
export type ServiceAreaAnchorPointsQueryVariables = Types.Exact<{
  serviceAreaId: Types.Scalars['ID']['input']
}>

export type ServiceAreaAnchorPointsQuery = {
  __typename?: 'Query'
  serviceAreaAnchorPoints: Array<{
    __typename?: 'AnchorPoint'
    name: string
    location: { __typename?: 'Location'; latitude: number; longitude: number }
  }>
}

export const ServiceAreaAnchorPointsDocument = gql`
    query serviceAreaAnchorPoints($serviceAreaId: ID!) {
  serviceAreaAnchorPoints(serviceAreaId: $serviceAreaId) {
    name
    location {
      latitude
      longitude
    }
  }
}
    `

/**
 * __useServiceAreaAnchorPointsQuery__
 *
 * To run a query within a React component, call `useServiceAreaAnchorPointsQuery` and pass it any options that fit your needs.
 * When your component renders, `useServiceAreaAnchorPointsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServiceAreaAnchorPointsQuery({
 *   variables: {
 *      serviceAreaId: // value for 'serviceAreaId'
 *   },
 * });
 */
export function useServiceAreaAnchorPointsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ServiceAreaAnchorPointsQuery,
    ServiceAreaAnchorPointsQueryVariables
  > &
    (
      | { variables: ServiceAreaAnchorPointsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ServiceAreaAnchorPointsQuery,
    ServiceAreaAnchorPointsQueryVariables
  >(ServiceAreaAnchorPointsDocument, options)
}
export function useServiceAreaAnchorPointsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ServiceAreaAnchorPointsQuery,
    ServiceAreaAnchorPointsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ServiceAreaAnchorPointsQuery,
    ServiceAreaAnchorPointsQueryVariables
  >(ServiceAreaAnchorPointsDocument, options)
}
// @ts-ignore
export function useServiceAreaAnchorPointsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ServiceAreaAnchorPointsQuery,
    ServiceAreaAnchorPointsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ServiceAreaAnchorPointsQuery,
  ServiceAreaAnchorPointsQueryVariables
>
export function useServiceAreaAnchorPointsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ServiceAreaAnchorPointsQuery,
        ServiceAreaAnchorPointsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ServiceAreaAnchorPointsQuery | undefined,
  ServiceAreaAnchorPointsQueryVariables
>
export function useServiceAreaAnchorPointsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ServiceAreaAnchorPointsQuery,
        ServiceAreaAnchorPointsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ServiceAreaAnchorPointsQuery,
    ServiceAreaAnchorPointsQueryVariables
  >(ServiceAreaAnchorPointsDocument, options)
}
export type ServiceAreaAnchorPointsQueryHookResult = ReturnType<
  typeof useServiceAreaAnchorPointsQuery
>
export type ServiceAreaAnchorPointsLazyQueryHookResult = ReturnType<
  typeof useServiceAreaAnchorPointsLazyQuery
>
export type ServiceAreaAnchorPointsSuspenseQueryHookResult = ReturnType<
  typeof useServiceAreaAnchorPointsSuspenseQuery
>
export type ServiceAreaAnchorPointsQueryResult = Apollo.QueryResult<
  ServiceAreaAnchorPointsQuery,
  ServiceAreaAnchorPointsQueryVariables
>
